import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
//const ServerUrl = "https://api.smsserpiolle.it"





const app = createApp(App).use(router);

//use the root instance to add your config
app.config.globalProperties.$hostname = "https://api.smsserpiolle.it"
//app.config.globalProperties.$hostname = "https://localhost:44353/"

// then you could mount it 



app.mount("#app")


